<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    :submit="submit"
    :status="status"
    :canCancel="false"
    :canUpdateDelete="false"
    next-link="/admin/suggested_prices"
    :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '#'
        },
        {
          text: '...',
          disabled: false,
          href: '#'
        },
        {
          text: 'Editar',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row no-gutters justify="center">
        <v-col cols="6">
          <v-row no-gutters justify="center">
            <v-col class="d-flex justify-center">
              <ValidationProvider
                ref="commission_percentage"
                rules="percentage_valid|required"
                v-slot="{ errors }"
              >
              <div class="label-base pb-1">Comisión</div>
                <v-text-field
                  name="commission_percentage"
                  label="Comisión"
                  prepend-inner-icon="fas fa-percent"
                  append-icon="$caretDownUpIcon"
                  type="number"
                  solo
                    hide-details="auto"
                    class="input-base custom-number"
                  v-model="data.commission_percentage"
                  :error-messages="errors[0]"
                  :error="errors.length > 0"
                >
              <template #prepend-inner>
                    <span class="fonts-s14 fonts-400 fonts-family-DMSans fonts-color-gray3">% </span>
                  </template>
                  <template #append>
                    <div class="number-controls">
                      <v-icon @click="data.commission_percentage++">
                        $chevronUpIcon
                      </v-icon>
                      <v-icon @click="data.commission_percentage = Math.max(0, data.commission_percentage - 1)">
                        $chevronDownIcon
                      </v-icon>
                    </div>
                  </template>
              </v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";
import Swal from "sweetalert";
export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Commissions",
      title: "Comisión",
      data: {
        commission_percentage: null,
        id: this.$route.params.id,
      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Tags.status,
    }),
  },
  watch: {},
  methods: {
    async submit() {
      const self = this;
      let valid = await self.$refs.validator.validate();
      if (valid) {
        let saveUrl = this.$route.params.id
          ? `${this.storeName}/update`
          : `${this.storeName}/create`;
        self.$store
          .dispatch(saveUrl, self.data)
          .then(function() {
            Swal(
              "Comisión Actualizada",
              "existosamente",
              "success",
              {
                buttons: false,
                timer: 3000,
              }
            );
          })
          .catch(function(response) {
            for (const i in response.errors) {
              try {
                eval("self.$refs." + i + ".setErrors(response.errors[i]);");
              } catch (error) {
                //
              }
            }
          });
      }
    },
  },
};
</script>
